module.exports = __webpack_public_path__ + "images/emoji_4ea2a8eda2218693d010c29776fef4ce8.svg";